export default __webpack_public_path__ + "static/media/lesson-image.a17c78fb.png";